module.exports = __webpack_public_path__ + "static/media/RW.34eae6ef.svg";